
























































































































































































































































































































































































































































































































import { Component } from 'vue-property-decorator';
import { AuthModule } from '@/store/Auth/AuthModule';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import ProductSubType from '@/models/Products/ProductSubType';
import PageNames from '@/router/PageNames';
import PermissionUtils from '@/lib/permissionUtils';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";

@Component({ name: 'ProductWizardSelector', components: { Alert }, metaInfo: { title: 'Product Wizard' } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;
    FeatureToggleCode = FeatureToggleCode;
    ProductSubType = ProductSubType;

    get institutionConfig() {
        return AuthModule.me.institution.config;
    }

    launchWizard(subType: ProductSubType) {
        this.$router.push({ name: PageNames.ProductWizard, query: { productSubType: subType } });
    }

}
